import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, PrimaryButton, TertiaryButton } from '@stashinvest/ui';
import { trackOnSetupResults } from './LinkPlaidEvents';
import { v1_ExternalAccountLinkSetupResults_ViewedProperties } from '@stashinvest/product-events-javascript/lib/v1/properties';

const LinkPlaidError = ({ linkAnotherBank, linkManually, trackEvent, isOnboarding }) => {
	useEffect(() => {
		if (!trackEvent) return;
		trackOnSetupResults(
			isOnboarding,
			trackEvent,
			v1_ExternalAccountLinkSetupResults_ViewedProperties.Result.failure
		);
	}, [trackEvent, isOnboarding]);
	return (
		<>
			<Text.H3 mb="min" align="center">
				We couldn’t link your bank this way.
			</Text.H3>
			<Text mb="m" align="center">
				Try linking with a different bank or manually link with your checking and routing
				numbers.
			</Text>
			<PrimaryButton
				onClick={() => {
					linkAnotherBank();
				}}
			>
				Link another bank
			</PrimaryButton>
			<Flex justifyContent="center">
				<TertiaryButton
					onClick={() => {
						linkManually();
					}}
				>
					Link manually instead
				</TertiaryButton>
			</Flex>
		</>
	);
};

LinkPlaidError.propTypes = {
	linkAnotherBank: PropTypes.func,
	linkManually: PropTypes.func,
	isOnboarding: PropTypes.bool,
};

export default LinkPlaidError;
